import Quill from 'quill';
import { useCallback } from 'react';

import { FontAwesomeIcon } from '@hivebrite/design-system/FontAwesomeIcon';

import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';

import ToolbarItem from '../components/ToolbarItem';

const Delta = Quill.import('delta');

const Mentions = () => {
  const { quillRef, options, setForceEditorFocus } = useQuillEditorContext();

  const { toolbar: toolbarOptions } = options;

  const handleMentions = useCallback(() => {
    if (!quillRef.current || typeof toolbarOptions?.mentions !== 'object') {
      return;
    }

    // Force focus for get selection
    quillRef.current.focus();

    const { index: cursorPos = 0 } = quillRef.current.getSelection() ?? {};

    // Add space before char if we have content
    const insert = `${quillRef.current.getLength() === 1 ? '' : ' '}${
      toolbarOptions?.mentions?.chars[0]
    }`;

    const delta = new Delta().retain(cursorPos).insert(insert);

    quillRef.current.updateContents(delta);

    // Delay setSelection
    setTimeout(() => {
      quillRef.current?.setSelection(
        cursorPos + insert.length,
        0,
        Quill.sources.SILENT,
      );
    }, 1);

    setForceEditorFocus?.(false);
  }, [quillRef, toolbarOptions?.mentions, setForceEditorFocus]);

  return (
    <ToolbarItem
      onMouseDown={() => setForceEditorFocus?.(true)}
      onClick={handleMentions}
      icon={<FontAwesomeIcon iconName="at" height="16px" />}
      ariaLabel={s__('QuillEditorAccessibility|Mention someone')}
      enableFontAwesomeIcon
    />
  );
};

export default Mentions;
